var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 58,
    viewBox: "0 0 252 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.0432 12.1294C51.0264 11.9943 51.0348 11.8569 51.0677 11.7256C51.1007 11.5944 51.1575 11.4722 51.2347 11.3668C51.3118 11.2613 51.4077 11.175 51.5161 11.113C51.6245 11.0511 51.7432 11.0151 51.8647 11.0071H71.9918C72.1273 10.989 72.2646 11.0056 72.3935 11.0557C72.5224 11.1057 72.6395 11.1878 72.7359 11.2958C72.8324 11.4039 72.9057 11.535 72.9503 11.6794C72.995 11.8238 73.0098 11.9776 72.9937 12.1294V18.0214C72.9937 18.319 72.8881 18.6045 72.7003 18.8149C72.5124 19.0254 72.2575 19.1437 71.9918 19.1437H59.1782V30.6696H68.6156C68.7417 30.6522 68.8697 30.6667 68.9901 30.712C69.1105 30.7573 69.2204 30.8321 69.3117 30.9311C69.4029 31.0301 69.4732 31.1507 69.5175 31.2841C69.5617 31.4175 69.5788 31.5603 69.5674 31.7021V37.3135C69.5686 37.5927 69.4769 37.8624 69.3102 38.0699C69.1435 38.2774 68.9137 38.4079 68.6657 38.4358H59.1782V44.9899C59.1782 45.6745 58.8576 46 58.1764 46H51.7646C51.6561 45.993 51.55 45.9616 51.4526 45.9078C51.3551 45.8539 51.2683 45.7787 51.1973 45.6866C51.1263 45.5945 51.0726 45.4874 51.0392 45.3716C51.0058 45.2558 50.9936 45.1336 51.0032 45.0124L51.0432 12.1294Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.0056 12.0349C76.9983 11.8961 77.0171 11.7572 77.0607 11.6275C77.1044 11.4977 77.1719 11.38 77.2588 11.2822C77.3457 11.1845 77.45 11.109 77.5646 11.0607C77.6792 11.0125 77.8015 10.9926 77.9235 11.0024H84.013C84.2617 11.0015 84.5015 11.1074 84.6844 11.2988C84.8674 11.4902 84.9801 11.7531 85 12.0349V44.96C85 45.6333 84.6644 45.9924 84.013 45.9924H77.9235C77.8 46.0104 77.6746 45.9962 77.5567 45.9509C77.4388 45.9056 77.3315 45.8303 77.2431 45.7307C77.1546 45.6312 77.0872 45.5101 77.0461 45.3765C77.0049 45.243 76.9911 45.1005 77.0056 44.96V12.0349Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.894 33.805L101.139 22.5829V44.9597C101.139 45.633 100.789 45.9921 100.137 45.9921H93.9252C93.8025 46.0077 93.6783 45.9925 93.5615 45.9476C93.4447 45.9026 93.3383 45.8292 93.2501 45.7324C93.1618 45.6357 93.0939 45.5182 93.0512 45.3884C93.0086 45.2587 92.9922 45.1199 93.0034 44.9821V12.0341C92.9961 11.8964 93.015 11.7585 93.0587 11.6296C93.1025 11.5006 93.1701 11.3835 93.2572 11.286C93.3443 11.1884 93.4489 11.1126 93.564 11.0636C93.6792 11.0147 93.8023 10.9935 93.9252 11.0017H100.177C100.814 11.0903 101.423 11.3397 101.961 11.7311L113.894 22.4033V12.0341C113.887 11.8964 113.906 11.7585 113.949 11.6296C113.993 11.5006 114.061 11.3835 114.148 11.286C114.235 11.1884 114.34 11.1126 114.455 11.0636C114.57 11.0147 114.693 10.9935 114.816 11.0017H120.998C121.247 11.0151 121.483 11.1258 121.666 11.3145C121.849 11.5032 121.967 11.7579 122 12.0341V44.9597C122 45.633 121.649 45.9921 120.998 45.9921H114.816C114.691 46.0106 114.564 45.9965 114.445 45.9512C114.325 45.9058 114.217 45.8303 114.128 45.7305C114.039 45.6307 113.971 45.5092 113.931 45.3756C113.89 45.2419 113.878 45.0996 113.894 44.9597V33.805Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.013 12.0363C126.011 11.8924 126.036 11.7498 126.087 11.6176C126.139 11.4854 126.215 11.3667 126.311 11.2694C126.407 11.172 126.52 11.0981 126.644 11.0525C126.767 11.007 126.898 10.9908 127.028 11.005H149.982C150.238 11.0041 150.485 11.1098 150.673 11.301C150.861 11.4922 150.977 11.7548 150.998 12.0363V17.8986C151.007 18.0523 150.988 18.2065 150.942 18.3517C150.895 18.4969 150.822 18.6299 150.726 18.7425C150.631 18.855 150.516 18.9447 150.388 19.0059C150.26 19.067 150.122 19.0984 149.982 19.098H142.632V44.8791C142.632 45.1764 142.525 45.4615 142.335 45.6717C142.144 45.8819 141.886 46 141.617 46H135.353C135.084 46 134.825 45.8819 134.635 45.6717C134.445 45.4615 134.338 45.1764 134.338 44.8791V19.098H127.018C126.878 19.0984 126.74 19.067 126.612 19.0059C126.484 18.9447 126.369 18.855 126.274 18.7425C126.178 18.6299 126.105 18.4969 126.058 18.3517C126.012 18.2065 125.993 18.0523 126.002 17.8986L126.013 12.0363Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.008 12.1228C154.991 11.9789 155.001 11.8324 155.04 11.6937C155.078 11.555 155.143 11.4276 155.23 11.3207C155.317 11.2137 155.424 11.1299 155.543 11.0752C155.662 11.0205 155.791 10.9963 155.919 11.0043H176.564C176.698 10.9905 176.832 11.01 176.957 11.0614C177.083 11.1127 177.197 11.1947 177.292 11.3014C177.386 11.4081 177.459 11.5371 177.504 11.679C177.55 11.821 177.567 11.9725 177.555 12.1228V17.9952C177.555 18.2919 177.45 18.5764 177.265 18.7861C177.079 18.9959 176.827 19.1138 176.564 19.1138H163.098V26.8206H173.485C174.01 26.8206 174.406 27.0778 174.406 27.7378V32.8048C174.403 32.9331 174.378 33.0595 174.332 33.1766C174.285 33.2937 174.219 33.3992 174.136 33.4867C174.053 33.5743 173.955 33.6422 173.848 33.6864C173.742 33.7307 173.628 33.7504 173.515 33.7444H163.078V37.8383H177.05C177.182 37.8146 177.317 37.8278 177.444 37.8768C177.571 37.9258 177.685 38.0091 177.777 38.1194C177.869 38.2297 177.935 38.3636 177.971 38.5096C178.006 38.6555 178.009 38.8091 177.98 38.9568V44.874C177.98 45.1706 177.876 45.4551 177.69 45.6649C177.505 45.8747 177.253 45.9925 176.99 45.9925H155.919C155.798 46.0102 155.674 45.9965 155.558 45.9525C155.442 45.9085 155.336 45.8353 155.248 45.7384C155.16 45.6416 155.093 45.5235 155.052 45.3932C155.01 45.2628 154.995 45.1236 155.008 44.9858V12.1228Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.763 14.7351L204.183 20.4947C203.859 21.0015 203.526 21.2204 203.03 20.7596C201.616 19.516 199.871 18.8614 198.085 18.905C193.433 18.905 190.106 23.1786 190.106 28.4774C190.106 33.7762 193.433 38.0037 198.085 38.0037C199.883 38.0095 201.634 37.3462 203.071 36.1145C203.153 36.0271 203.253 35.9624 203.361 35.9254C203.469 35.8884 203.583 35.8802 203.694 35.9014C203.806 35.9225 203.911 35.9724 204.003 36.0473C204.095 36.1222 204.17 36.2201 204.223 36.3334L207.854 42.2888C208.188 42.8417 207.915 43.4407 207.389 43.7862C205.286 45.4187 202.877 46.4657 200.354 46.8427C197.831 47.2198 195.266 46.9165 192.865 45.9571C190.464 44.9978 188.295 43.4093 186.532 41.3198C184.768 39.2302 183.461 36.698 182.715 33.9273C181.968 31.1566 181.804 28.2248 182.234 25.3684C182.665 22.512 183.679 19.8109 185.194 17.4827C186.71 15.1545 188.684 13.2645 190.958 11.9649C193.233 10.6653 195.743 9.99249 198.287 10.0008C201.532 9.96649 204.708 11.0638 207.389 13.1455C207.743 13.5717 208.167 14.1361 207.763 14.7351Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.001 12.0334C212 11.8993 212.022 11.7662 212.067 11.6417C212.112 11.5173 212.179 11.4039 212.264 11.308C212.348 11.2121 212.449 11.1357 212.56 11.083C212.671 11.0303 212.791 11.0025 212.912 11.001H219.229C219.484 11.0001 219.73 11.1059 219.917 11.2973C220.105 11.4887 220.221 11.7516 220.241 12.0334V29.0008H230.799V12.0334C230.798 11.8945 230.822 11.7567 230.87 11.6285C230.918 11.5002 230.989 11.3842 231.079 11.2876C231.169 11.191 231.276 11.1157 231.393 11.0664C231.511 11.0171 231.636 10.9949 231.761 11.001H237.986C238.553 11.001 238.999 11.304 238.999 11.9885V44.9582C239.006 45.1037 238.984 45.2492 238.934 45.3843C238.885 45.5193 238.809 45.6405 238.712 45.7392C238.616 45.8379 238.5 45.9116 238.375 45.9551C238.249 45.9986 238.117 46.0107 237.986 45.9906H231.7C231.573 46.0058 231.445 45.9898 231.324 45.9438C231.203 45.8978 231.093 45.8229 231.001 45.7244C230.909 45.6258 230.838 45.5061 230.793 45.3737C230.747 45.2413 230.729 45.0994 230.738 44.9582V37.3722H220.231V44.9582C220.231 45.609 219.826 45.9906 219.168 45.9906H212.912C212.795 46.0089 212.677 45.9985 212.564 45.96C212.452 45.9216 212.348 45.856 212.261 45.7681C212.174 45.6802 212.106 45.5721 212.061 45.4515C212.016 45.3309 211.995 45.2007 212.001 45.0704V12.0334Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_442_357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 28.41V28.4115V28.4129V28.4144V28.4159V28.4173V28.4188V28.4202V28.4217V28.4232V28.4246V28.4261V28.4276V28.429V28.4305V28.4319V28.4334V28.4349V28.4363V28.4378V28.4393V28.4407V28.4422V28.4436V28.4451V28.4466V28.448V28.4495V28.4509V28.4524V28.4538V28.4553V28.4568V28.4582V28.4597V28.4611V28.4626V28.464V28.4655V28.467V28.4684V28.4699V28.4713V28.4728V28.4742V28.4757V28.4771V28.4786V28.4801V28.4815V28.483V28.4844V28.4859V28.4873V28.4888V28.4902V28.4917V28.4931V28.4946V28.496V28.4975V28.4989V28.5004V28.5019V28.5033V28.5048V28.5062V28.5077V28.5091V28.5106V28.512V28.5135V28.5149V28.5164V28.5178V28.5193V28.5207V28.5221V28.5236V28.525V28.5265V28.5279V28.5294V28.5308V28.5323V28.5337V28.5349C10.5425 27.7332 14.152 28.7499 17.0041 29.5533C17.07 29.5719 17.1355 29.5904 17.2006 29.6087L6.5 28.41ZM6.5 28.41C6.5 23.6634 8.40472 19.1099 11.7971 15.751C15.1896 12.392 19.7922 10.5027 24.5933 10.5C25.1111 10.5009 25.6286 10.5232 26.1444 10.567C26.2192 11.812 26.2131 13.0606 26.126 14.3051L26.126 14.3051L26.1257 14.3103C25.8484 18.9739 25.3984 22.6413 24.7726 25.3057C24.4596 26.6379 24.1063 27.7037 23.7173 28.5119C23.3256 29.3255 22.9159 29.8399 22.5116 30.118L22.5116 30.118M6.5 28.41L22.5116 30.118M22.5116 30.118L22.508 30.1205M22.5116 30.118L22.508 30.1205M22.508 30.1205C22.0848 30.417 21.5033 30.5151 20.6142 30.4097M22.508 30.1205L20.6142 30.4097M20.6142 30.4097C19.722 30.304 18.6147 30.0063 17.2006 29.6087L20.6142 30.4097Z",
    fill: "#009FE3",
    stroke: "#009FE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2065 14.5897L31.2067 14.5854C31.2553 13.6345 31.2655 12.6821 31.2372 11.7305C33.9033 12.7851 36.2844 14.4602 38.1809 16.6212C40.2406 18.9683 41.6587 21.8087 42.2973 24.8665C42.9359 27.9243 42.7733 31.0954 41.8252 34.0716C40.8772 37.0479 39.176 39.7281 36.887 41.8517C34.598 43.9754 31.7991 45.4702 28.7622 46.1912C25.7253 46.9121 22.5537 46.8345 19.5556 45.966C16.5576 45.0974 13.8349 43.4675 11.6523 41.2345C9.58822 39.1227 8.0735 36.5395 7.23707 33.7117C10.2514 33.0718 13.0345 33.8564 15.8838 34.6597L15.8888 34.6611L15.8913 34.6618C15.953 34.6788 16.0148 34.6959 16.0768 34.7131C17.5655 35.1248 19.1531 35.5639 20.7087 35.6649C22.3458 35.7711 23.9859 35.5067 25.4901 34.4354L25.4915 34.4344C27.2291 33.1876 28.4783 31.0782 29.3821 27.8891C30.2863 24.6988 30.8622 20.3653 31.2065 14.5897Z",
    fill: "#009FE3",
    stroke: "#009FE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_442_357",
    x: 47,
    y: 11,
    width: 30,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_442_357",
    x: 73,
    y: 11,
    width: 16,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_442_357",
    x: 89,
    y: 11,
    width: 37,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_442_357",
    x: 122,
    y: 11,
    width: 33,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_442_357",
    x: 151,
    y: 11,
    width: 31,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_442_357",
    x: 178,
    y: 10,
    width: 34,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_442_357",
    x: 208,
    y: 11,
    width: 35,
    height: 43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_442_357",
    x: 2,
    y: 10,
    width: 45.1801,
    height: 45.1801,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_442_357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_442_357",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/LoginLogo.c067845d077cda3bc73e568869b33ef2.svg";
export { ForwardRef as ReactComponent };